var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repoFile"},[(_vm.fileIsReady)?_c('vMarkdown',{attrs:{"md":_vm.file}}):_c('vLoading',{attrs:{"title":_vm.filePath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }